module.exports = {
  prod: {
    httpUrl: 'http://123.56.84.49:', // 上线配置
    port: '80'
  },
  baseUrl () {
    const str = this.prod.httpUrl + this.prod.port + '/v1/'
    return str
  }
}



// WEBPACK FOOTER //
// ./src/api/apiConfig.js